export default __webpack_public_path__ + "static/media/stock_icon.dcb3e8bb.svg";